import owasp from 'owasp-password-strength-test';

class PasswordFieldset {
  constructor(el) {
    this.container = el;
    this.password_field = el.querySelector('input[data-role="password"]');
    this.confirmation_block = el.querySelector('[data-role="confirmation"]');
    this.confirmation_field = this.confirmation_block.querySelector('input');
    this.form = el.closest('form');
    if (this.form) this.submitter = this.form.querySelector('input[type="submit"]');

    const meter_holder = el.querySelector('[data-role="meter"]');
    if (meter_holder) {
      this.meter = new PasswordMeter(meter_holder);
    }

    this.password_field.addEventListener('input', this.checkPassword.bind(this));
    this.confirmation_field.addEventListener('input', this.checkConfirmation.bind(this));
    this.checkPassword();
  }

  checkPassword() {
    if (this.empty) {
      this.confirmable = false;
      this.password_field.classList.remove('valid')
      this.password_field.classList.remove('invalid')
      if (this.meter) this.meter.hide();
      if (this.required) this.submittable = false;
      else this.submittable = true;
      return false;
    }

    const password = this.password_field.value;
    let ok = false;
    if (this.meter) {
      ok = this.meter.check(password);
    } else {
      ok = true;
    }

    if (ok) {
      this.password_field.classList.remove('invalid');
      this.password_field.classList.add('valid');
    } else {
      this.password_field.classList.remove('valid');
      this.password_field.classList.add('invalid');
    }

    this.confirmable = ok;
    this.checkConfirmation();
    return ok;
  }

  checkConfirmation() {
    if (this.confirmed) {
      this.confirmation_field.classList.remove('invalid');
      this.confirmation_field.classList.add('valid');
      this.submittable = true;
    } else {
      this.confirmation_field.classList.remove('valid');
      this.confirmation_field.classList.add('invalid');
      this.submittable = this.empty && !this.required;
    }
  }

  get required() {
    return this.password_field.required
  }

  get confirmed() {
    return this.password_field.value === this.confirmation_field.value;
  }

  get empty() {
    return !this.password_field.value
  }

  get valid() {
    return this.confirmed && !(this.empty && this.required)
  }

  set confirmable(value) {
    if (value) {
      this.confirmation_field.required = true;
      this.confirmation_field.disabled = false;
      this.confirmation_block.classList.add('available');
    } else {
      this.confirmation_field.required = false;
      this.confirmation_field.disabled = true;
      this.confirmation_block.classList.remove('available');
    }
  }

  set submittable(value) {
    if (value) {
      if (this.submitter) this.submitter.disabled = false;
    } else {
      if (this.submitter) this.submitter.disabled = true;
    }
  }
}

const status_classes = ['bad', 'middling', 'good']

class PasswordMeter {
  constructor(el) {
    this.container = el;
    this.warnings = el.querySelector('[data-role="warnings"]');
    this.gauge = el.querySelector('[data-role="gauge"]');
    this.score = el.querySelector('[data-role="score"]');
    if (this.warnings) this.original_warning = this.warnings.innerHTML;
  }

  clear() {
    if (this.warnings) this.warnings.innerHTML = this.original_warning;
    this.container.classList.remove(...status_classes);
  }

  check(value) {
    owasp.config({
      allowPassphrases       : true,
      maxLength              : 128,
      minLength              : 6,
      minPhraseLength        : 12,
      minOptionalTestsToPass : 2,
    });
    const result = owasp.test(value);
    this.display(result);
    return result.strong;
  }

  hide() {
    this.container.classList.remove('active');
  }

  display(result) {
    this.clear();
    if (this.warnings) {
      if (!result.strong) {
        if (result.requiredTestErrors && result.requiredTestErrors.length) {
          this.container.classList.add('active', `bad`);
          this.warnings.innerText = result.requiredTestErrors.join(' ');
        } else {
          this.warnings.innerText = "Password not very strong.";
          this.container.classList.add('active', `middling`);
        }
      } else {
        this.warnings.innerText = "Password looks OK.";
        this.container.classList.add('active', `good`);
      }
    }
  }
}

function passwordFieldset(el) {
  return new PasswordFieldset(el);
}

function passwordMeter(el) {
  return new PasswordMeter(el);
}


export {
  passwordFieldset,
  passwordMeter,
};